import React from 'react';
import useDebugInformation from '../../../../hooks/useDebugInformation';
import AnonymousView from './AnonymousView';
import AuthenticatedView from './AuthenticatedView';
import './index.css';
import { AuthContext } from '../../../../utilities/authProvider';

const name = "LoginMenu"

const LoginMenu: React.FC = () => {
    const { isAuthenticated } = React.useContext(AuthContext);

    useDebugInformation(name, { isAuthenticated });

    return (
        !isAuthenticated
            ? <AnonymousView />
            : <AuthenticatedView />
    )
}

LoginMenu.displayName = name;

export default React.memo(LoginMenu);